export default "__VITE_ASSET__53fa5017__"